export default __webpack_public_path__ + "static/media/icon-close.ac0b7f84.svg";